"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var RandomSlot = function (_a) {
    var playRandomGame = _a.playRandomGame;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.cardTitle }, t('iAmOnTheWildSide')),
        react_1.default.createElement("img", { className: styles_module_scss_1.default.imgRandom, src: "/img/promo-blocks/randomGameBackground.png", alt: "random game" }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", maxWidth: "100%", height: "55px", onClick: playRandomGame }, t('randomGame')))));
};
exports.default = react_1.default.memo(RandomSlot);
